import React from "react"
import styled from "styled-components"
import { graphql, Link } from "gatsby"
import { Icon } from "@mostlycode/ui"
import Content from "components/Content"
import NavList from "components/Navigation/NavList"
import Legal from "./Legal"
import Section from "../Section"

const StyledFooter = styled.footer`
  padding: 4rem 0;
  background: ${(props) => props.theme.colors.primary};

  h4 {
    margin-top: 0;
    font-size: 2.1rem;
  }
`

const StyledLogo = styled(Link)`
  display: block;
  max-width: 13.4rem;

  svg {
    transition: fill ease-out 0.2s;
    width: 13.4rem;
    height: 8.4rem;
    fill: ${(props) => props.theme.colors.plush};

    .headroom--pinned & {
      fill: ${(props) => props.theme.colors.primary};
    }
  }
`

const StyledAddress = styled.address`
  font-style: normal;
  color: ${(props) => props.theme.colors.white};

  a {
    color: ${(props) => props.theme.colors.plush};
  }

  p {
    margin: 0;
    line-height: 1.5;
  }

  h4 {
    margin-top: 0;
    margin-bottom: 1rem;

    ${(props) => props.theme.media.tablet_landscape_up`
      line-height: 1em;
      margin-bottom: 2rem;
    `}
  }
`

const StyledInnerFooter = styled.div`
  display: grid;
  grid-template-rows: repeat(auto-fill, 1fr);
  grid-row-gap: 3rem;

  ${(props) => props.theme.media.tablet_landscape_up`
    grid-template-columns: 1fr 1fr 1fr 1fr;
  `}
`

const StyledNavlist = styled(NavList)`
  margin: 0;
  list-style: none;
  padding: 0;

  li {
    line-height: 1.5;
    padding: 0.5rem 0;

    a {
      margin: 0;
      padding: 0;
      border: none;
      color: ${(props) => props.theme.colors.ice};
      text-transform: none;
      &.active,
      &:hover {
        border: none;
      }
    }
  }
`

const StyledNavs = styled.nav``

function Footer({
  footer_information,
  footer_navigations,
  lang,
  children,
  ...props
}) {
  return (
    <StyledFooter>
      <Section bg="primary" color="ice">
        <StyledInnerFooter>
          <StyledLogo to={lang === "en-gb" ? "/en" : "/"}>
            <Icon icon="logo" title="Mostly Code Logo" />
          </StyledLogo>
          <StyledAddress>
            <Content content={footer_information} />
          </StyledAddress>
          <StyledNavs>
            {footer_navigations.map((nav, i) => {
              const {
                footer_navigation_title,
                footer_navigation: { navigation_items },
              } = nav
              return (
                <div key={`nav_${i}`}>
                  <h4>{footer_navigation_title}</h4>
                  <StyledNavlist items={navigation_items} />
                </div>
              )
            })}
          </StyledNavs>
          {children}
        </StyledInnerFooter>
        <Legal />
      </Section>
    </StyledFooter>
  )
}

export default Footer

export const query = graphql`
  fragment FooterNavigation on PRISMIC_Site_settings {
    footer_navigations {
      footer_navigation {
        ... on PRISMIC_Navigation {
          navigation_items {
            navigation_children {
              ... on PRISMIC_Navigation {
                navigtion_title
                _meta {
                  id
                  lang
                  type
                }
              }
            }
            navigation_link {
              ... on PRISMIC_Page {
                title
                _meta {
                  lang
                  uid
                  type
                }
              }
            }
            navigation_link_text
          }
        }
      }
      footer_navigation_title
    }
  }
`
